/*!
 * devextreme-angular
 * Version: 19.1.3
 * Build date: Tue May 14 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';





import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';


@Component({
    selector: 'dxo-collision',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoCollisionComponent extends NestedOption {
    @Input()
    get x(): string {
        return this._getOption('x');
    }
    set x(value: string) {
        this._setOption('x', value);
    }

    @Input()
    get y(): string {
        return this._getOption('y');
    }
    set y(value: string) {
        this._setOption('y', value);
    }


    protected get _optionPath() {
        return 'collision';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

}

@NgModule({
  declarations: [
    DxoCollisionComponent
  ],
  exports: [
    DxoCollisionComponent
  ],
})
export class DxoCollisionModule { }
